/** * 框架组件 * 徐杰 * 2019-4-19 **/
<template>
  <Layout>
    <!-- 头部区域 -->
    <Header class="header">
      <Row>
        <!-- logo -->
        <i-col span="14" class="logo">
          <img src="../assets/huanbao.png" class="tximg1" /><span class="logo-title"
            >无锡市新吴生态环境局污染物排放过程监控及分析系统</span
          >
        </i-col>
        <!-- 菜单部分 -->
        <!-- <i-col span="10" /> -->
        <!-- 个人信息 -->
        <i-col span="10" class="txt-right">
          <Row>
            <div class="boxtime">
              <Icon type="ios-calendar-outline" class="timesty" />
              <span>{{ timeText }}</span>
            </div>

            <!-- 头像 -->
            <Dropdown class="info1" @on-click="rigthDropdown">
              <img src="../assets/tx.png" class="tximg2" />
              <span class="unit-name">{{ unitName }}</span>
              <Icon type="md-arrow-dropdown" style="color: #4183bd" size="18" />
              <DropdownMenu slot="list">
                <DropdownItem name="dd0"><i class="icon iconfont icon-mima" /> 修改密码</DropdownItem>
                <!-- <DropdownItem>
                    我的信息
                    <Badge status="error" />
                  </DropdownItem> -->
                <DropdownItem name="dd1" divided><i class="icon iconfont icon-denglu" /> 退出登录</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <!-- </i-col> -->
          </Row>
        </i-col>
      </Row>
    </Header>
    <!-- end头部区域 -->
    <Modal v-model="outLoginModel" title="退出系统提示" @on-ok="outLogin">
      <p>您是否确认退出系统！</p>
    </Modal>
    <Layout>
      <!-- 左边二级菜单 -->
      <Sider v-model="isCollapsed" class="sider" width="240" collapsible :class="{ 'sider-hide': isCollapsed }">
        <X-Menu :menu-item="menuList" :is-collapsed="isCollapsed" />
      </Sider>
      <Content class="content" :class="{ 'content-expand': isCollapsed }">
        <slot>
          <!-- 标签引入内容区 -->
        </slot>
      </Content>
    </Layout>
    <!-- 右边抽屉 -->
    <Drawer v-model="openDrawer" title="这里是标题" :closable="false">
      <p>这里是内容...</p>
    </Drawer>
  </Layout>
</template>

<script>
import XMenu from './xMenu.vue';
import { parseTime } from '@/utils/date.js';
export default {
  components: { XMenu },
  data() {
    return {
      intvalTime: '',
      timeText: '',
      selname: this.$route.selbtn,
      count: 5, // 消息数量
      openDrawer: false, // 默认关闭右边抽屉
      isCollapsed: false, // 记录左边菜单 拉伸
      outLoginModel: false, // 退出系统提示框
    };
  },
  mounted() {
    this.getRealTime();
    this.$nextTick(() => {
      if (this.intvalTime) {
        clearInterval(this.intvalTime);
      }
      this.intvalTime = setInterval(() => {
        this.getRealTime();
      }, 1000);
    });
  },
  computed: {
    // 顶部昵称显示
    unitName() {
      return JSON.parse(localStorage.getItem('AC_USER_INFO')).unit_name;
    },
    // 菜单需要的路由信息
    menuList() {
      return this.$router.options.routes;
    },
  },
  methods: {
    getRealTime() {
      this.timeText = parseTime(new Date(), '{y}年{m}月{d}日 {h}:{i}:{s} 星期{a}');
    },
    /**
     * 右上角头像 菜单点击事件
     */
    rigthDropdown(name) {
      switch (name) {
        case 'dd0': // 修改密码
          break;
        case 'dd1': // 退出登录
          this.outLoginModel = true;
          break;
      }
    },
    /**
     * 退出系统事件
     */
    outLogin() {
      this.$Message.success(`退出系统中...`);
      localStorage.removeItem('AC_USER_INFO');
      sessionStorage.removeItem('AC_ACCESS_TOKEN');
      // 定时跳转
      setTimeout(() => {
        this.$router.push('login');
      }, 1500);
    },
  },
};
</script>

<style>
.ivu-layout {
  min-height: 100vh;
}
/* 覆盖菜单下边阴影 */
.ivu-menu-horizontal.ivu-menu-light:after {
  background: none;
}
/* 头部 */
.header {
  width: 100%;
  height: 60px;
  /* color: #fff; */
  background: #051e34;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  color: #9bb4ca;
}
.ivu-row {
  justify-content: flex-end;
}
.boxtime {
  margin-right: 20px;
  color: #9bb4ca;
  font-size: 16px;
}
.timesty {
  margin-right: 5px;
  font-weight: bold;
}
.logo-title {
  font-weight: bold;
  text-shadow: 2px 2px 1px rgba(80, 90, 110, 0.2);
  color: #0062ff;
  font-size: 20px;
}
.ivu-layout-header {
  padding: 0 22px 0 12px;
}
.logo {
  font-size: 20px;
  height: 60px;
}
.menu {
  height: 60px;
}
.tximg1 {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.tximg2 {
  width: 36px;
  height: 36px;
  vertical-align: middle;
}
.unit-name {
  margin-left: 4px;
  font-size: 16px;
  vertical-align: middle;
}
.notification {
  text-align: center;
  height: 200px;
}
.txt-right {
  text-align: right;
}
.info1 {
  text-align: left;
}
/* 左边菜单 */
.sider {
  position: fixed;
  height: 100%;
  left: 0;
  top: 60px;
  overflow: auto;
  z-index: 10;
}

/* 设置右边菜单隐藏时的一些变化 */
.sider-hide .ivu-menu span {
  display: none;
}
.sider-hide .ivu-menu-item {
  padding-left: 28px !important;
}

/* 设置内容页面 */
.content {
  margin-left: 240px;
  margin-top: 60px;
  padding: 16px;
  transition: all 0.2s ease-in-out;
  min-width: 900px;
}
.content-expand {
  margin-left: 64px;
}
</style>
